export const getOperatorStatus = state => {
  return state.SupportCenterReducer.operatorStatus;
};

export const getSessionName = state => {
  return state.SupportCenterReducer.sessionDetails 
    && state.SupportCenterReducer.sessionDetails.sessionName;
};

export const getSessionKey = state => {
  return state.SupportCenterReducer.sessionDetails 
    && state.SupportCenterReducer.sessionDetails.sessionKey;
};

export const getSessionCreatedTime = state => {
  return state.SupportCenterReducer.sessionDetails 
    && state.SupportCenterReducer.sessionDetails.sessionCreatedTime;
};

export const getIsTransfer = state => {
  return state.SupportCenterReducer.sessionDetails 
    && state.SupportCenterReducer.sessionDetails.isTransfer;
};

export const getNumberOfCallsWaiting = state => {
  return state.SupportCenterReducer.numberOfCallsWaiting;
};

export const getTransferDestinationOperatorList = state => {
  return state.SupportCenterReducer.transferDestinationOperatorList;
};

export const getIsTransferError = state => {
  return state.SupportCenterReducer.isTransferError;
};

export const getRequirement = state => {
  return state.SupportCenterReducer.sessionDetails 
    && state.SupportCenterReducer.sessionDetails.requirement;
};

export const getIsWebWorkerError = state => {
  return state.SupportCenterReducer.isWebWorkerError;
};
